module.exports = __webpack_public_path__ + "static/media/calendar-big.20cbdb09.svg";